import React from "react";

function SocialLinksSection({
  facebook,
  instagram,
  youtube,
  onFacebookChange,
  onInstagramChange,
  onYoutubeChange,
}) {
  return (
    <section
      className="ap-pane"
      aria-labelledby="ep-pane-social"
      data-section="social-links"
    >
      <header className="ap-pane__head">
        <h2 id="ep-pane-social">
          <i className="fa-solid fa-share-nodes" aria-hidden="true"></i>Соціальні мережі
        </h2>
        <p>Додайте посилання на свої сторінки — вони з'являться кнопками на вашому профілі.</p>
      </header>

      <div className="ap-row ap-row--3">
        <div className="ap-field">
          <label htmlFor="facebook-link">
            <i className="fa-brands fa-facebook" aria-hidden="true"></i>Facebook
          </label>
          <input
            type="url"
            className="form-control"
            id="facebook-link"
            name="facebook"
            data-field="facebook"
            autoComplete="url"
            placeholder="https://facebook.com/..."
            value={facebook}
            onChange={(e) => onFacebookChange(e.target.value)}
          />
        </div>
        <div className="ap-field">
          <label htmlFor="instagram-link">
            <i className="fa-brands fa-instagram" aria-hidden="true"></i>Instagram
          </label>
          <input
            type="url"
            className="form-control"
            id="instagram-link"
            name="instagram"
            data-field="instagram"
            autoComplete="url"
            placeholder="https://instagram.com/..."
            value={instagram}
            onChange={(e) => onInstagramChange(e.target.value)}
          />
        </div>
        <div className="ap-field">
          <label htmlFor="youtube-link">
            <i className="fa-brands fa-youtube" aria-hidden="true"></i>YouTube
          </label>
          <input
            type="url"
            className="form-control"
            id="youtube-link"
            name="youtube"
            data-field="youtube"
            autoComplete="url"
            placeholder="https://youtube.com/..."
            value={youtube}
            onChange={(e) => onYoutubeChange(e.target.value)}
          />
        </div>
      </div>
    </section>
  );
}

export default SocialLinksSection;
